module.exports = __webpack_public_path__ + "img/wx.3b34326c.webp";